<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<form
  class="modal-form"
  [formGroup]="form"
  *ngIf="form"
  (submit)="submit()"
  id="form"
>
  <div class="integrity-form-card__loading" *ngIf="pageLoading">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <header class="integrity-form-card__header">
    <div>
      <h2>
        {{ isEdit ? 'Editar Integridade' : 'Nova Integridade' }}
      </h2>
      <p>
        Defina as informações utilizadas na monitoração e automações de integridade.
      </p>
    </div>
  </header>

    <div class="integrity-form-card__body">
    <div class="integrity-form-field integrity-form-field--full">
      <label for="integrityName" class="integrity-form-label">
        Nome <span class="integrity-form-required">*</span>
      </label>
      <input
        id="integrityName"
        type="text"
        pInputTextarea
        pInputText
        class="integrity-form-input"
        formControlName="integrityName"
        required
      />
      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityName')?.touched && form.get('integrityName')?.invalid"
      >
        Informe um nome valido (max. 50).
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--full">
      <label for="integrityViewName" class="integrity-form-label">
        Nome da View <span class="integrity-form-required">*</span>
      </label>
      <input
        id="integrityViewName"
        type="text"
        pInputTextarea
        pInputText
        class="integrity-form-input"
        formControlName="integrityViewName"
        required
      />
      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityViewName')?.touched && form.get('integrityViewName')?.invalid"
      >
        Informe um nome de view valido (max. 255).
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--full">
      <label for="integrityDescription" class="integrity-form-label">Descricao</label>
      <textarea
        id="integrityDescription"
        pInputTextarea
        class="integrity-form-input integrity-form-input--textarea"
        formControlName="integrityDescription"
        rows="3"
      ></textarea>
      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityDescription')?.touched && form.get('integrityDescription')?.invalid"
      >
        Descricao muito longa (max. 255).
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--half integrity-form-field--color">
      <label for="integrityColor" class="integrity-form-label">Cor</label>
      <div class="integrity-form-color">
        <input
          id="integrityColor"
          type="text"
          pInputText
          class="integrity-form-input integrity-form-input--color"
          formControlName="integrityColor"
          placeholder="#FF0000"
        />

        <p-colorPicker
          class="color-swatch"
          [ngModel]="pickerValue"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onPickerChange($event)"
          format="hex"
          [showButtons]="false"
          appendTo="body"
          aria-label="Selecionar cor"
        ></p-colorPicker>
      </div>

      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityColor')?.touched && form.get('integrityColor')?.invalid"
      >
        Informe uma cor valida (#RGB ou #RRGGBB) - max. 10 caracteres.
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--half">
      <label for="integrityCategoryId" class="integrity-form-label">
        Categoria <span class="integrity-form-required">*</span>
      </label>
      <p-dropdown
        class="integrity-form-select"
        inputId="integrityCategoryId"
        [options]="categories"
        optionLabel="integrityCategoryName"
        optionValue="integrityCategoryId"
        formControlName="integrityCategoryId"
        placeholder="Selecione"
        [filter]="true"
        [showClear]="true"
      ></p-dropdown>
      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityCategoryId')?.touched && form.get('integrityCategoryId')?.invalid"
      >
        Selecione uma categoria.
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--full integrity-form-field--switch">
      <div class="integrity-form-label">
        <label for="automaticUpdate">Atualizacao automatica</label>
        <span class="integrity-form-helper">
          Inclui esta integridade nas rotinas agendadas.
        </span>
      </div>
      <p-inputSwitch
        class="integrity-form-switch"
        formControlName="automaticUpdate"
        inputId="automaticUpdate"
      ></p-inputSwitch>
    </div>

    <div class="integrity-form-field integrity-form-field--full integrity-form-field--switch">
      <div class="integrity-form-label">
        <label for="enableToViews">Exibir nas views</label>
        <span class="integrity-form-helper">
          Controla se a integridade aparece nas telas/consultas.
        </span>
      </div>
      <p-inputSwitch
        class="integrity-form-switch"
        formControlName="enableToViews"
        inputId="enableToViews"
      ></p-inputSwitch>
    </div>

    <div class="integrity-form-field integrity-form-field--full">
      <label for="integrityQuery" class="integrity-form-label">
        Query SQL <span class="integrity-form-required">*</span>
      </label>
      <textarea
        id="integrityQuery"
        pInputTextarea
        class="integrity-form-input integrity-form-input--textarea"
        formControlName="integrityQuery"
        rows="9"
        placeholder="SELECT * FROM ..."
      ></textarea>
      <small
        class="integrity-form-error"
        *ngIf="form.get('integrityQuery')?.touched && form.get('integrityQuery')?.invalid"
      >
        Informe a query (SELECT).
      </small>
    </div>

    <div class="integrity-form-field integrity-form-field--half">
      <label for="resolutionType" class="integrity-form-label">
        Tipo de resolucao <span class="integrity-form-required">*</span>
      </label>
      <p-dropdown
        class="integrity-form-select"
        inputId="resolutionType"
        [options]="resolutionOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="resolutionType"
        placeholder="Selecione"
      ></p-dropdown>
      <small
        class="integrity-form-error"
        *ngIf="form.get('resolutionType')?.touched && form.get('resolutionType')?.invalid"
      >
        Selecione um tipo de resolucao.
      </small>
    </div>

    <div
      class="integrity-form-field integrity-form-field--full"
      *ngIf="form.get('resolutionType')?.value === 'JAVA_HANDLER'"
    >
      <p-message
        class="integrity-form-info"
        severity="info"
        text="Crie um handler Java com o mesmo nome da view para orquestrar a resolucao."
      ></p-message>
    </div>

    <div
      class="integrity-form-field integrity-form-field--full"
      *ngIf="form.get('resolutionType')?.value === 'JAVA_HANDLER_STANDALONE'"
    >
      <p-message
        class="integrity-form-info"
        severity="info"
        text="Este handler busca seus próprios dados internamente — nenhuma query de integridade é necessária. Configure apenas o Handler Name correspondente."
      ></p-message>
    </div>

    <div
      class="integrity-form-field integrity-form-field--full"
      *ngIf="form.get('resolutionType')?.value === 'SQL_SCRIPT'"
    >
      <label for="resolutionQuery" class="integrity-form-label">
        Script de resolucao <span class="integrity-form-required">*</span>
      </label>
      <textarea
        id="resolutionQuery"
        pInputTextarea
        class="integrity-form-input integrity-form-input--textarea"
        formControlName="resolutionQuery"
        rows="7"
        placeholder="UPDATE ... SET ..."
      ></textarea>
      <small
        class="integrity-form-error"
        *ngIf="form.get('resolutionQuery')?.touched && form.get('resolutionQuery')?.invalid"
      >
        Informe o script SQL que corrige os registros.
      </small>
    </div>

      <div class="integrity-form-actions integrity-form-field--full">
        <button
          pButton
          type="submit"
          label="Salvar"
          icon="pi pi-check"
          [disabled]="form.invalid || loading"
        ></button>
      </div>
    </div>

    <div class="integrity-form-card__overlay" *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
</form>
